const TopBarPowerBI = ({ callback }) => {
  return (
    <div className="top-bar">
      <h2>PowerBI Docs</h2>
    </div>
  )
}

export default TopBarPowerBI
